const layouts = {
  maxWidth: '1256px',
  pagePadding: 'clamp(2rem, 8vw, 4rem)',
};
export default layouts;
